export const GUESTWATCH_URL = 'https://complaint-blocking-guest.lovable.app';
